import {
  CheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
  Checkbox as MaterialCheckbox,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useMemo } from "react";
import { black, disabledGray, disabledGrayBackground, lightBackground, white } from "shared/designSystem/theme";

export type Props = CheckboxProps &
  Omit<FormControlLabelProps, "control" | "className"> & {
    filled?: boolean;
    preventDefaultClick?: boolean;
  };

const Checkbox = React.forwardRef(
  ({ label, value, disabled, filled, onChange, preventDefaultClick = false, ...props }: Props, ref) => {
    const labelElement = useMemo(() => <Typography fontSize={12}>{label}</Typography>, [label]);

    return (
      <StyledLabel
        {...props}
        label={labelElement}
        ref={ref}
        onChange={onChange}
        onClick={e => {
          if (preventDefaultClick) e.preventDefault();
        }}
        control={
          <BlackCheckbox
            checked={!!value}
            disabled={disabled}
            size="small"
            sx={
              filled
                ? {
                    "&.Mui-checked": {
                      color: white,
                    },
                  }
                : {}
            }
          />
        }
      />
    );
  },
);

const StyledLabel = styled(FormControlLabel)({
  marginLeft: 0,
  textWrap: "nowrap",
});

const BlackCheckbox = styled(MaterialCheckbox)({
  "&.MuiCheckbox-root": {
    marginLeft: 0,
    paddingLeft: 0,
    paddingRight: "4px",
    color: black,
  },
});

const StyledCheckbox = styled(Checkbox)(({ theme, value, filled, disabled }) => {
  if (!filled) return;

  let backgroundColor = value ? black : lightBackground;
  let color = value ? white : black;

  if (disabled) {
    backgroundColor = disabledGrayBackground;
    color = disabledGray;
  }

  const baseStyle = {
    height: "30px",
    padding: theme.spacing(1),
    border: `1px solid ${disabled ? disabledGray : black}`,
    borderRadius: theme.spacing(0.5),
    color,
    backgroundColor,
    "& .MuiTypography-root": {
      fontSize: theme.typography.pxToRem(14),
    },
  };

  return baseStyle;
});

export default StyledCheckbox;
